;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React, { Suspense } from 'react';

import { graphRequest } from 'services/contentful';

import { assetFragment, linkFragment } from 'lib/graphql/fragments';

import BlockProducts from './BlockProducts';

const query = /* GraphQL */ `
    ${assetFragment}
    ${linkFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockProducts(preview: $preview, id: $id) {
            __typename
            anchorId
            title
            productsCollection(limit: 200) {
                items {
                    sys {
                        id
                    }
                    __typename
                    slug
                    displayName
                    eyebrow
                    color
                    attributes
                    displayName
                    category {
                        slug
                        title
                        attributes
                    }
                    image {
                        ...Asset
                    }
                    icon
                }
            }
            cardDistribution
            cardsCollection(limit: 10) {
                items {
                    ... on Entry {
                        __typename
                        sys {
                            id
                        }
                    }
                    ... on CardFlip {
                        title
                        imagePortrait {
                            ...Asset
                        }
                        imageLandscape {
                            ...Asset
                        }
                        frontText
                        frontTextColor
                        backText {
                            json
                        }
                        backBackgroundColor
                    }
                    ... on CardInternalLink {
                        title
                        imageDesktop {
                            ...Asset
                        }
                        imageMobile {
                            ...Asset
                        }
                        text
                        textColor
                        link {
                            ...EntryLink
                        }
                    }
                }
            }
            useCategorySort
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockProducts },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });

    return blockProducts;
}

const BlockProductsServer = async ({ id, firstBlock }) => {
    const block = await fetchBlock(id);
    const products = block.productsCollection.items;
    const cards = block.cardsCollection?.items || [];
    return (
        <Suspense>
            <BlockProducts
                {...block}
                firstBlock={firstBlock}
                products={products}
                cards={cards}
            />
        </Suspense>
    );
};

export default BlockProductsServer;
